import { render } from "./officeAssign.vue?vue&type=template&id=0c5ae690&scoped=true"
import script from "./officeAssign.vue?vue&type=script&lang=js"
export * from "./officeAssign.vue?vue&type=script&lang=js"

import "./officeAssign.vue?vue&type=style&index=0&id=0c5ae690&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5ae690"]])

export default __exports__